import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useIsPhone } from '../../hooks/useIsPhone';

/**
 * Restreint la navigation mobile (téléphone ≤ 767px) aux non-admins :
 * seuls `/calendrier` et `/calendrier-prestation` sont accessibles.
 * Toute autre route est redirigée vers `/calendrier`.
 * Admins et utilisateurs sur tablette/desktop : aucune restriction.
 */
const ALLOWED_PHONE_PATHS = new Set(['/calendrier', '/calendrier-prestation']);
const ALLOWED_PHONE_PREFIXES = ['/clients/']; // la fiche client (ouverte depuis calendrier prestation) est autorisée en lecture seule

export function PhoneNavGuard({ children }) {
    const { user } = useAuth();
    const isPhone = useIsPhone();
    const location = useLocation();
    if (!user) return children;
    if (user.role === 'admin') return children;
    if (!isPhone) return children;
    const path = location.pathname;
    if (ALLOWED_PHONE_PATHS.has(path)) return children;
    if (ALLOWED_PHONE_PREFIXES.some(p => path.startsWith(p))) return children;
    return <Navigate to="/calendrier" replace />;
}
